// extracted by mini-css-extract-plugin
export default {"slide":"index_slide_6GusM","slideBox":"index_slideBox_6cS0a"};